<script>
import Vue from 'vue'
import VueRouter from 'vue-router';

import App from './App.vue'
import About from './About.vue'

import FlowerList from './FlowerList/main.vue'
import ActRules from './ActRules/main.vue'

import Qna from './Qna/main.vue'
import act from './Qna/act.vue'
import brand from './Qna/brand.vue'
import diamond from './Qna/diamond.vue'
import lottery from './Qna/lottery.vue'
import pot from './Qna/pot.vue'
import report from './Qna/report.vue'
import notice from './Qna/notice.vue'



import IIndex from './Index/index.vue'
import Product from './Index/ProductIntro.vue'



Vue.use(VueRouter); //vue router 必加

// const scrollBehavior = function (to, from, savedPosition) {
//     // savedPosition 会在你使用浏览器前进或后退按钮时候生效
//     // 这个跟你使用 router.go() 或 router.back() 效果一致
//     // 这也是为什么我在 tab 栏结构中放入了一个 点击回退 的按钮
//     if (savedPosition) {
//         return savedPosition
//         } else {
//         // 如果不是通过上述行为切换组件，就会让页面回到顶部
//         return {x: 0, y: 0}
//     }
// }


const router = new VueRouter({
    //scrollBehavior,
    routes: [
        {
            
            path: '/',
            component: App,
            children: [
                
                {
                    path: 'product-intro',
                    component: IIndex,
                    name: 'product-intro',
                    meta: {
                        title: '商品介紹-bodum 北歐時尚 品味生活'
                    }
                },
                {
                    path: 'brand-intro',
                    component: IIndex,
                    name: 'brand-intro',
                    meta: {
                        title: '品牌介紹-bodum 北歐時尚 品味生活'
                    }
                },
                {
                    path: 'flower-list',
                    component: IIndex,
                    name: 'flower-list',
                    meta: {
                        title: '印花攻略-bodum 北歐時尚 品味生活'
                    }
                },
                {
                    path: 'card-download',
                    component: IIndex,
                    name: 'card-download',
                    meta: {
                        title: '收集卡下載-bodum 北歐時尚 品味生活'
                    }
                },
                {
                    path: '',
                    component: IIndex,
                    name: 'index',
                    meta: {
                        title: 'bodum 北歐時尚 品味生活'
                    }
                },
                {
                    path: 'about',
                    component: About,
                    meta: {
                        title: 'bodum 北歐時尚 品味生活'
                    }
                },
                {
                    path: 'FlowerList/:id?',
                    component: FlowerList,
                    props: true,
                    meta: {
                        title: '印花攻略-bodum 北歐時尚 品味生活'
                    }
                    // children: [
                    //     {
                    //         path: '*',
                    //         // redirect: '/FlowerList/1',
                    //     }

                    // ]
                },
                {
                    path: 'ActRules',
                    component: ActRules,
                    meta: {
                        title: '活動辦法-bodum 北歐時尚 品味生活'
                    }
                },
                {
                    path: 'Qna',
                    component: Qna,
                    meta: {
                        title: '常見問題-bodum 北歐時尚 品味生活',
                        secure: false
                    },
                    props: true,
                    children: [
                        {name: 'act', path: "act", component: act, meta: {
                            title: '常見問題-bodum 北歐時尚 品味生活',
                            secure: false
                        }},
                        {name: 'brand', path: "brand", component: brand,  meta: {
                            title: '常見問題-bodum 北歐時尚 品味生活',
                            secure: false
                        }},
                        {name: 'report', path: "report", component: report, meta: {
                            title: '常見問題-bodum 北歐時尚 品味生活',
                            secure: false
                        }},
                        {name: 'pot', path: "pot", component: pot, meta: {
                            title: '常見問題-bodum 北歐時尚 品味生活',
                            secure: false
                        }},
                        {name: 'diamond', path: "diamond", component: diamond, meta: {
                            title: '常見問題-bodum 北歐時尚 品味生活',
                            secure: false
                        }},
                        {name: 'lottery', path: "lottery", component: lottery, meta: {
                            title: '常見問題-bodum 北歐時尚 品味生活',
                            secure: false
                        }},
                        {
                            name: 'notice', 
                            path: "notice/:id?", 
                            component: notice, 
                            props: true, 
                            meta: {
                                title: '產品注意事項-bodum 北歐時尚 品味生活',
                                secure: false
                            }
                        },
                        {path: "", component: act, meta: {
                            title: '常見問題-bodum 北歐時尚 品味生活',
                            secure: false
                        }}
                    ]
                    
                },
                {
                    path: 'products/:id',
                    component: Product,
                    name: 'products',
                    props: true,
                    meta: {
                        title: 'bodum 北歐時尚 品味生活',
                        secure: false
                    }
                },
                {
                    path: '*',
                    redirect: '/',
                    //也可以用{name: xxx}
                }
            ]
            
        },  
    ]

});

router.beforeEach((to, from, next) => {
    document.title = to.meta.title;  //这 to.meta.title 是在router里设置的
    next();
});



export default router;




</script>


// WEBPACK FOOTER //
// src/router.vue